import React from "react";
import { makePost, makePatch } from "@culturehq/client";
import { Button } from "@culturehq/components";
import * as CHQ from "chq";

import { useAsyncAction } from "app/hooks";
import { t } from "app/utils";

import styles from "./event-rsvp-options.module.scss";

const rsvpOptions = [
  { name: t("Yes"), value: "accepted" },
  { name: t("No"), value: "declined" },
  { name: t("Interested"), value: "interested" }
];

type SaveRsvpOpts = {
  eventId: number;
  rsvpId?: number;
  responseType: CHQ.Rsvp["responseType"];
};

type SaveRsvp = ((_opts: SaveRsvpOpts) => Promise<{ rsvp: CHQ.Rsvp }>);

const saveRsvp: SaveRsvp = ({ eventId, rsvpId, responseType }) => {
  if (!rsvpId) {
    return makePost(`/events/${eventId}/rsvps`, { responseType });
  }

  return makePatch(`/events/${eventId}/rsvps/${rsvpId}`, { responseType });
};

type EventRsvpOptionsProps = {
  event: CHQ.EventWithRsvp;
  onEventUpdate: (_update: Partial<CHQ.EventWithRsvp>) => void;
  onRefreshInvitations: () => void;
};

type RsvpForUser = {
  id?: number;
  responseType?: CHQ.Rsvp["responseType"];
};

const EventRsvpOptions: React.FC<EventRsvpOptionsProps> = ({
  event,
  onEventUpdate,
  onRefreshInvitations
}) => {
  const rsvpForUser: RsvpForUser = event.rsvpForUser || {};

  const { onTrigger, performing } = useAsyncAction(
    async responseType => {
      const { rsvp } = await saveRsvp({ eventId: event.id, rsvpId: rsvpForUser.id, responseType });
      onEventUpdate({ rsvpForUser: rsvp });
      onRefreshInvitations();
    }
  );

  return (
    <div className={styles.options}>
      {rsvpOptions.map(rsvpOption => (
        <Button
          key={rsvpOption.value}
          className={styles.option}
          inverted={rsvpOption.value !== rsvpForUser.responseType}
          onClick={() => onTrigger(rsvpOption.value)}
          disabled={performing}
        >
          {rsvpOption.name}
        </Button>
      ))}
    </div>
  );
};

export default EventRsvpOptions;
